<template>
  <div>

    <form class="desktop-search loaded" :class="{'dealer-search': isdealer}" action="search">
        <input type="text" name="q" v-bind:placeholder="placeholder" :aria-label="placeholder" 
        ref="search_input" v-model="search_phrase">
        <button type="submit" class="desktop-search-submit" aria-label="Search"></button>
    </form>

    <div class="search-banner" v-if="hasAnyImage && searchbannerdata.isEnabled && is_dealer == 0">
      <div class="row">
        <div 
          v-if="searchbannerdata.imageUrl && searchbannerdata.url" 
            :class="columnClass"
            class="image-container"      
            style="padding-right:10px"
          >
          <a :href="searchbannerdata.url">
            <img class="full-img" :src="searchbannerdata.imageUrl" >
          </a>
        </div>
        <div 
          v-if="searchbannerdata.imageUrl2 && searchbannerdata.url2" 
            :class="columnClass"
            class="image-container"   
            style="padding-left:10px"
          >
          <a :href="searchbannerdata.url2">
            <img class="full-img" :src="searchbannerdata.imageUrl2" >
          </a>
        </div>
      </div>
    </div>

    <div class="box-list" v-show="showResults">
      <div class="row">
        <div class="col-lg-12 products">
          <div class="row" :class="results.length === 5 ? 'center-row' : 'align-row'">
            <div class="panel col-12" v-for="(result, index) in this.results" :key="index">
              <div class="item">
                  <div class="top">
                    <a :href="result.url">
                      <div class="fmv-image bglazyload" v-bind:style="{ 'background-image': 'url(' + result.image + ')' }">
                      </div>
                    </a>
                    <div class="stock-code">{{ result.stockCode }}</div>
                    <a :href="result.url">
                      <div class="title"><a v-html="result.title"></a></div>
                    </a>
                  </div>
                  <div class="bottom" v-if="0">
                    <div class="price" v-if="!hide_price_global_value && !result.isObsolete">
                      <div class="amount">
                        <div class="full-price" v-if="result.salePrice == ''">{{ result.fullPrice }}</div>
                        <div class="sale-price" v-if="result.salePrice != ''">{{ result.salePrice }}</div>
                      </div>
                      <div class="gst">{{ result.gst }}</div>
                    </div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box-list" v-show="loading" dusk="loading_overlay">
      <p class="loading">
        <img src="/cdn/images/loading.gif" width="100" />
      </p>
    </div>
    <div class="box-list" v-if="!loading && !showResults && search_phrase && search_phrase.length > 2">
      <h3 style="text-align: center;">No results found.</h3>
    </div>
  </div>
</template>
<script>
export default {
  name: "search-form",
  props: {
    placeholder: String,
    searchvisible : Boolean,
    isdealer: Boolean,
    searchbannerdata: Object,
    is_dealer: String,
    hide_price_global_value: {
      type: Number,
      default: 0
    },
  },
  data: function() {
    return {
    search_phrase: '',
    loading: false,
    results: [],
    showResults: false,
    };
	},
  computed: {
    hasAnyImage() {
      return this.searchbannerdata?.imageUrl || this.searchbannerdata?.imageUrl2;
    },
    columnClass() {
      const count = [this.searchbannerdata.imageUrl, this.searchbannerdata.imageUrl2].filter(Boolean).length;
      return count === 1 ? 'col-md-12 col-sm-12' : 'col-md-6 col-sm-12';
    }
  },
  watch : {
 		searchvisible : function(newVal, oldVal) {
            if(newVal){
            	setTimeout(() => {
               		this.$refs.search_input.focus();
            		}, 100);
            }
        },
    async search_phrase() {
      if (this.search_phrase.length > 2) {
        this.showResults = false;
        this.loading = true;
        try {
          let url = `search-live?q=${this.search_phrase}`;
          // console.log(url);
          let response = await axios.get(url);
          let search_phrase_comp = this.search_phrase.trim().replace(/ /gi, "%20");
          // console.log(response.request.responseURL.split("?q=")[1], search_phrase_comp);
          if (response.request.responseURL.split("?q=")[1] == search_phrase_comp) {
            this.results = response.data;
            this.loading = false;
            this.showResults = true;
            // console.log('result ',this.results,'response data', response.data);
          }
        } catch (err) {} 
        finally {
          this.loading = false;
        }
      } else {
            this.loading = false;
            this.showResults = false;
      }
    },
  },

};
</script>
<style lang="scss" scoped>
.center-row{
  justify-content: center;
}
.align-row{
  margin: 0 80px !important;
}
.fmv-image {
    max-width: 255px;
    height: 152px;
    margin: 0 auto 15px auto;
    width: 100%;
    overflow: hidden;
    background-repeat: no-repeat;
    background-position: center;
    //background-size: cover;
    background-size: contain;
    position: relative;
}
</style>
